// ======================================================================
// File Name       : ContentDrillRegisterAdvance
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Col, FormControl } from 'react-bootstrap';
import FileUpload from '../../components/FileUpload';
import FormControlValidate from '../../components/FormControlValidate';
import { CONTENT_DRILL_OBJECT } from '../../constants/ContentConstant';
import { VALIDATE_TYPE } from '../../constants/index';
import * as MessageTemplate from '../../constants/MessageTemplate';

class ContentDrillRegisterAdvance extends React.Component {
  constructor(props) {
    super(props);
    this.validation = this.validation.bind(this);
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }
  render() {
    const {
      handleChange,
      openOrCloseAdvanceSettings,
      buttonText,
      isClosed,
      timeLimit,
      drillTimeLimit,
      fullMark,
      acquisition,
      countingMethod,
      scoringRule,
      useJudgment,
      partialPoint,
      useNote,
      useHTML,
      handleFileChange,
      fileName,
      remark,
    } = this.props;
    this.refsToValidate = [];
    const fullMarkRequired = parseInt(scoringRule, 10) === 1 || parseInt(scoringRule, 10) === 2;
    return (
      <div className="col-sm-12">
        <Form.Group className="form-info margin-top-20">
          <Col sm={12} as={Form.Label} className="padding-left-5">
            <a role="presentation" className={buttonText} onClick={openOrCloseAdvanceSettings}>
              詳細設定
            </a>
          </Col>
        </Form.Group>
        {!isClosed &&
        <div>
          <Form.Group className="form-info">
            <Col sm={2} as={Form.Label} className="padding-right-clear">
              制限時間
            </Col>
            <Col sm={2} as={Form.Label} className="padding-left-right-clear">
              対象
            </Col>
            <Col sm={7}>
              <Col sm={4} className="padding-left-right-clear padding-top-3">
                <Form.Check
                  type='radio'
                  inline
                  name="timeLimitNotUsed"
                  id="timeLimitNotUsed"
                  value={CONTENT_DRILL_OBJECT.DO_NOT_USE}
                  checked={timeLimit === CONTENT_DRILL_OBJECT.DO_NOT_USE}
                  onChange={handleChange}
                  label='利用しない'></Form.Check>
              </Col>
              <Col sm={4} className="padding-top-3">
                <Form.Check
                  type='radio'
                  inline
                  name="timeLimitDrill"
                  id="timeLimitDrill"
                  value={CONTENT_DRILL_OBJECT.DRILL_PRIORITY}
                  checked={timeLimit === CONTENT_DRILL_OBJECT.DRILL_PRIORITY}
                  onChange={handleChange}
                  label='ドリル優先'></Form.Check>
              </Col>
              <Col sm={4} className="padding-top-3">
                <Form.Check
                  type='radio'
                  inline
                  name="timeLimitQuestion"
                  id="timeLimitQuestion"
                  value={CONTENT_DRILL_OBJECT.QUESTION_PRIORITY}
                  checked={timeLimit === CONTENT_DRILL_OBJECT.QUESTION_PRIORITY}
                  onChange={handleChange}
                  label='問題優先'></Form.Check>
              </Col>
            </Col>
          </Form.Group>
          {(timeLimit === CONTENT_DRILL_OBJECT.DRILL_PRIORITY || timeLimit === CONTENT_DRILL_OBJECT.QUESTION_PRIORITY) &&
          <div>
            {timeLimit === CONTENT_DRILL_OBJECT.DRILL_PRIORITY && <Form.Group className="form-info">
              <Col sm={2} className="padding-right-clear" />
              <Col sm={2} as={Form.Label} className="padding-left-right-clear">
                ドリル制限時間
              </Col>
              <Col sm={7}>
                <FormControlValidate
                  type="text"
                  maxLength="4"
                  name="drillTimeLimit"
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  value={drillTimeLimit}
                  label="ドリル制限時間"
                  onChange={handleChange}
                  validateType={VALIDATE_TYPE.NUMERIC}
                  messageError={MessageTemplate.MSG_NUMERIC_INVALID}
                  messageSuccess={MessageTemplate.MSG_NUMERIC_VALID}
                />
              </Col>
              <Col sm={1} className="text-left margin-top-10 padding-left-15">
                秒
              </Col>
            </Form.Group>}
            <Form.Group className="form-info">
              <Col sm={2} className="padding-right-clear" />
              <Col sm={2} as={Form.Label} className="padding-left-right-clear">
                タイマー超過時のアクション
              </Col>
              <Col sm={7}>
                <Form.Select
                  name="acquisition"
                  value={acquisition}
                  onChange={handleChange}
                >
                  <option value={0}>何もしない</option>
                  <option value={1}>強制終了</option>
                </Form.Select>
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={2} className="padding-right-clear" />
              <Col sm={2} as={Form.Label} className="padding-left-right-clear">
                カウント方法
              </Col>
              <Col sm={7}>
                <Form.Select
                  name="countingMethod"
                  value={countingMethod}
                  onChange={handleChange}
                >
                  <option value={1}>カウントアップ</option>
                  <option value={2}>カウントダウン</option>
                  <option value={3}>カウントアップバー</option>
                  <option value={4}>カウントダウンバー</option>
                </Form.Select>
              </Col>
            </Form.Group>
          </div>}
          <Form.Group className="form-info">
            <Col sm={4} as={Form.Label}>
              配点ルール
            </Col>
            <Col sm={7} >
              <Form.Select
                name="scoringRule"
                value={scoringRule}
                onChange={handleChange}
              >
                <option value={0}>絶対配点</option>
                <option value={1}>点数按分</option>
                <option value={2}>加重平均配点</option>
                <option value={3}>グループ配点</option>
              </Form.Select>
            </Col>
          </Form.Group>
          {(parseInt(scoringRule, 10) === 1 || parseInt(scoringRule, 10) === 2) && // #6582
          <Form.Group className="form-info">
            <Col sm={2} className="padding-right-clear" />
            <Col sm={2} as={Form.Label} className="padding-left-right-clear">
                  満点{fullMarkRequired && <span className="required">&nbsp;(※)</span>}
            </Col>
            <Col sm={7}>
              <FormControlValidate
                type="text"
                maxLength="4"
                name="fullMark"
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                value={fullMark}
                label="満点 "
                required={fullMarkRequired}
                onChange={handleChange}
                validateType={VALIDATE_TYPE.NUMERIC}
                messageError={MessageTemplate.MSG_NUMERIC_INVALID}
                messageSuccess={MessageTemplate.MSG_NUMERIC_VALID}
              />
            </Col>
            <Col sm={1} className="text-left margin-top-10 padding-left-15">
              点
            </Col>
          </Form.Group>}
          <Form.Group className="form-info">
            <Col sm={4} as={Form.Label}>
              △判定を使用する
            </Col>
            <Col sm={7} className="padding-top-10">
              <Form.Check
                type='checkbox'
                className="padding-clear padding-top-clear"
                name="useJudgment"
                id="useJudgment"
                checked={useJudgment}
                onChange={handleChange} />
            </Col>
          </Form.Group>
          {useJudgment &&
          <Form.Group className="form-info">
            <Col sm={2} className="padding-right-clear" />
            <Col sm={2} as={Form.Label} className="padding-left-right-clear">
              部分点付与
            </Col>
            <Col sm={7}>
              <FormControlValidate
                type="text"
                maxLength="4"
                label="部分点付与"
                name="partialPoint"
                value={partialPoint}
                onChange={handleChange}
                validateType={VALIDATE_TYPE.NUMERIC}
                required={useJudgment}
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
              />
            </Col>
            <Col sm={1} className="text-left margin-top-10 padding-left-15">
              %
            </Col>
          </Form.Group>}
          <Form.Group className="form-info">
            <Col sm={4} as={Form.Label}>
              注意点を使用する
            </Col>
            <Col sm={7} className="padding-top-10">
              <Form.Check
                type='checkbox'
                className="padding-clear padding-top-clear"
                name="useNote"
                id="useNote"
                checked={useNote}
                onChange={handleChange} />
            </Col>
          </Form.Group>
          {useNote ?
            <div>
              <Form.Group className="form-info">
                <Col sm={2} className="padding-right-clear" />
                <Col sm={2} as={Form.Label} className="padding-left-right-clear">
                  内容
                </Col>
                <Col sm={7} className="padding-top-10">
                  <Col sm={6} className="padding-clear">
                    <Form.Check
                      type='radio'
                      inline
                      className="padding-top-clear"
                      name="notUseHTML"
                      id="notUseHTML"
                      value={!useHTML}
                      checked={!useHTML}
                      onChange={handleChange}
                      label='HTMLを使用しない'></Form.Check>
                  </Col>
                  <Col sm={6}>
                    <Form.Check
                      type='radio'
                      inline
                      className="padding-top-clear"
                      name="useHTML"
                      id="useHTML"
                      value={useHTML}
                      checked={useHTML}
                      onChange={handleChange}
                      label='HTMLを使用する'></Form.Check>
                  </Col>
                  {useHTML &&
                  <Col sm={12} className="padding-clear margin-top-10">
                    <FileUpload
                      labelName="ファイル選択"
                      id="contentDrillFileUpload"
                      onChange={handleFileChange}
                      fileName={fileName}
                      accept=".zip"
                    />
                  </Col>}
                  {!useHTML &&
                  <Col sm={12} className="padding-clear margin-top-10 margin-bottom-10">
                    <FormControlValidate
                      id="contentDrillRegisterRemark"
                      as="textarea"
                      className="textArea"
                      name="remark"
                      maxLength="30000"
                      onChange={handleChange}
                      value={remark}
                      label="内容"
                      ref={(ref) => {
                        if (ref) {
                          this.refsToValidate.push(ref);
                        }
                      }}
                      required
                    />
                    </Col>}
                  {useHTML &&
                  <Col sm={12} className="padding-clear margin-top-10">
                    <FormControlValidate
                      label="ファイル名"
                      validateType={VALIDATE_TYPE.LABEL}
                      value={fileName && `ファイル名：${fileName}`}
                      ref={(ref) => {
                        if (ref) {
                          this.refsToValidate.push(ref);
                        }
                      }}
                      required
                    />
                  </Col>}
                </Col>
              </Form.Group>
            </div> : null}
        </div>}
      </div>
    );
  }
}

export default ContentDrillRegisterAdvance;
